import React from "react";
import LayoutWrapper from "../components/layout/LayoutWrapper";
import Header from "../components/layout/Header";
import "./mocktest.css";

const MockTest = () => {
  return (
    <LayoutWrapper>
      <Header /> 
      <div className="mock-test-container">
        <div className="mock-test-content">
          <div className="mock-test-tophead">
            <h4>Mock Test</h4>
            <button>Create New</button>
          </div>
          <div className=""></div>
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default MockTest;
